import { BAOCustomElement } from '@bao/custom-element'
import {
  setInitialised,
  addWheelControls,
  useArrows,
  useDots,
} from '@bao/carousel'

const KeenSlider = window.KeenSlider

class CssCarousel extends BAOCustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()

    this.listeners.add(this, 'BAO::CSS_CAROUSEL::VISIBLE', this.handleVisible)
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    const plugins = [
      setInitialised(),
      useDots({
        dots: this.els?.dot?.elements,
        indicator: this.els?.indicator?.element,
      }),
      addWheelControls('horizontal'),
    ]

    if (this.els.arrows?.exists) {
      if (this.els.slide.elements.length > 2) {
        this.els.arrows.element.removeAttribute('aria-hidden')

        plugins.push(
          useArrows({
            next: this.els?.next?.element,
            previous: this.els?.previous?.element,
          }),
        )
      } else {
        this.els.arrows.element.setAttribute('aria-hidden', true)
      }
    }

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1000,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 'auto',
          spacing: this.dataset.spacing || 2,
        },
      },
      plugins,
    )
  }

  handleVisible () {
    requestAnimationFrame(() => {
      this.carousel?.update()
    })
  }
}

if (!customElements.get('css-carousel')) {
  customElements.define('css-carousel', CssCarousel)
}
